module.exports = {
          srcSet: __webpack_public_path__ + "e0f1ee1b03f0308652d83954022054f5-140.png"+" 140w",
          images:[ {path: __webpack_public_path__ + "e0f1ee1b03f0308652d83954022054f5-140.png",width: 140,height: 107}],
          src: __webpack_public_path__ + "e0f1ee1b03f0308652d83954022054f5-140.png",
          toString:function(){return __webpack_public_path__ + "e0f1ee1b03f0308652d83954022054f5-140.png"},
          
          width: 140,
          height: 107
        }